module.exports = __webpack_public_path__ + "static/img/form_bg.40ce11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/form_bg.png
// module id = wrXc
// module chunks = 1